import {Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular';
import { templateToastPosition } from './toast-service.functions';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    constructor(public toastController: ToastController) {}

    async presentErrorToast(errorMessage: string) {
        const toast = await this.toastController.create({
            message: errorMessage,
            duration: 3000,
            color: 'danger',
            position: this.getToastPosition(),
            cssClass: 'custom-toast-style'
        });
        toast.present();
    }

    async presentInfoToast(message: string) {
        const toast = await this.toastController.create({
            message,
            duration: 3000,
            color: 'primary',
            position: this.getToastPosition(),
            cssClass: 'custom-toast-style'
        });
        toast.present();
    }

    private getToastPosition(): 'top' | 'bottom' {
        return templateToastPosition({
            defaultTemplate: this.getToastPositionDefault,
            flowwwerTemplate: this.getToastPositionFlowwwer
        });
    }

    private getToastPositionFlowwwer() {
        return 'bottom';
    }

    private getToastPositionDefault() {
        return 'bottom';
    }
}
